import adminMessages from '@carsfinders/i18n/uk/admin.json';

/**
 * Rendered when api-node answers 401/403 inside a page — RequireAdmin sends
 * a missing or customer session to /login before any page mounts, so reaching
 * this means the session changed under an open tab (expired, or signed out
 * elsewhere). The way back is this SPA's own sign-in — a plain link, not a
 * router Link: the session is gone, so a full reload is the honest restart,
 * and the screen also renders outside the router (page-level tests).
 *
 * It used to end in an English hint and nothing to click but the shell's
 * «Вийти», which left for the auction's sign-out (reported 2026-09-26).
 */
export function AccessDenied() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-2xl font-bold text-gray-900">{adminMessages.accessDenied}</h1>
        <p className="text-gray-600">{adminMessages.noPermissionMessage}</p>
        <p className="mt-4 text-sm text-gray-500">{adminMessages.accessDeniedHint}</p>
        <a
          href="/login?reason=not-admin"
          className="mt-5 inline-flex h-10 items-center rounded-cf-md bg-cf-brand px-4 text-sm font-semibold text-white hover:bg-cf-brand-hover"
        >
          {adminMessages.signInAsAdmin}
        </a>
      </div>
    </div>
  );
}
